import { ALERTS_MANAGER_AVAILABLE } from 'src/api/consts';
import type { IServicesCollection } from 'src/packages/di';

import { AlertsPersonalPreferenceService } from './AlertsPersonalPreferenceService';
import type { IAlertsPersonalPreferenceService } from './IAlertsPersonalPreferenceService';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    alertsPersonalPreference: IAlertsPersonalPreferenceService;
  }
}

export async function addAlertsPersonalPreferenceService(di: IServicesCollection) {
  const service = new AlertsPersonalPreferenceService();

  di.addSingleton('alertsPersonalPreference', service);

  if (ALERTS_MANAGER_AVAILABLE) {
    await service.loadPreferences();
  }
}
